<template>
  <component :editTest="editTest" :is="activeTestMod" :tests="tests" :testsWithKey="testsWithKey"
             class="w-full"></component>
</template>

<script>
  import {eventBus} from "../../eventbus";
  import TestContent from "./TestContent";
  import TestAdd from "./TestAdd";
  import TestEdit from "./TestEdit";
  import firebase from "firebase";
  import {db} from '@/db'


  export default {
    name: "TestIndex",
    firebase: {
      tests: db.ref('test_centre').orderByChild('area'),
    },
    watch: {
      tests() {
        this.getKeys()
      }
    },
    data() {
      return {
        activeTestMod: 'TestContent',
        editTest: {},
        tests: [],
        testsWithKey: [],
      }
    },
    methods: {
      listener() {
        eventBus.$on('AddTest', () => this.activeTestMod = 'TestAdd')
        eventBus.$on('AllTest', () => this.activeTestMod = 'TestContent')
        eventBus.$on('EditTest', (x) => {
          this.activeTestMod = 'TestEdit';
          this.editTest = x
        })
      },
      getKeys() {
        let keys = []
        firebase.database().ref('test_centre/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.testsWithKey = keys
      },
    },
    components: {
      TestContent,
      TestAdd,
      TestEdit
    },
    created() {
      this.listener()
      // this.getKeys()
    }

  }
</script>

<style scoped>
  .button {
    background: #9BC4D5;
  }
</style>
